import { Component, signal } from '@angular/core';

import { FilesListComponent, FilesSlideComponent } from '@camelot/files-basic';
import { DocumentDto, FileType } from '@camelot/services';
import { EFileExtension, FileData } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

const files: FileData[] = [
  { fileExtension: EFileExtension.Image, id: 1, name: 'first.png', type: 'Image', url: 'https://mock.local/first.png' },
  {
    fileExtension: EFileExtension.Image,
    id: 2,
    name: 'second.png',
    type: 'Image',
    url: 'https://mock.local/second.png',
  },
];

const slideDocuments: DocumentDto[] = [
  {
    fileType: FileType.Unknown,
    id: 'slide-1',
    name: 'slide-one.png',
    uploadedDate: '2026-01-01T10:00:00Z',
    url: 'https://mock.local/slide-one.png',
  },
  {
    fileType: FileType.Unknown,
    id: 'slide-2',
    name: 'slide-two.png',
    uploadedDate: '2026-01-01T10:00:00Z',
    url: 'https://mock.local/slide-two.png',
  },
];

@Component({
    imports: [FilesListComponent, FilesSlideComponent, TestIdDirective],
    template: `
    <cam-files-list camTestId="fb-list" [files]="this.files" (fileSelected)="this.onSelected($event)" />
    <div camTestId="fb-selected">{{ this.selected() }}</div>

    <cam-files-slide camTestId="fb-slide" [initial]="this.initial" [files]="this.slideDocuments" />
  `
})
export class FilesBehaviorCase {
  public files = files;
  public initial = slideDocuments[0];
  public selected = signal('');
  public slideDocuments = slideDocuments;

  public onSelected(file: FileData & { index: number }): void {
    this.selected.set(`${file.name}#${file.index}`);
  }
}
